export default __webpack_public_path__ + "static/media/spotify_green.b315c450.png";